import { render, staticRenderFns } from "./PaginationPanel.vue?vue&type=template&id=ec1febfa&"
import script from "./PaginationPanel.vue?vue&type=script&lang=js&"
export * from "./PaginationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports